import React from "react";
import { Navbar12 } from "./components/Navbar12";
import { Footer5 } from "./components/Footer5";

export default function Page() {
  return (
    <div>
      <Navbar12 />
      <Footer5 />
    </div>
  );
}
